'use client'
import { LinkExternal } from '@/types/common/LinkExternal'
import s from './Footer.module.scss'
import { useRef, useState } from 'react'
import Link from 'next/link'
import React from 'react'
import Logo from '../Logo'
import { baseUrl, createWPFooterSchema } from '@/lib/constants'


interface menu {
    linksSocial: Array<LinkExternal>;
    links: Array<LinkExternal>;
    description: string | null;
    newsletterText: string | null;
    copyright: string | null;
}

interface FooterProps {
    footer: menu;
}

interface DataProps {
    data: FooterProps;

}

export default function Footer({
    data
}: DataProps) {

    const inputRef = useRef(null)
    const [email, setEmail] = useState('');
    const [result, setResult] = useState(null)
    const [hideClassName, setHideClassName] = useState(false)
    const [hideClassEmail, setHideClassEmail] = useState(false)

    const subscribeUser = async (e) => {
        e.preventDefault()
        console.log(email);
        const res = await fetch('/api/subscribeUser', {
            body: JSON.stringify({
                email: { email }
            }),
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST'
        })

        setResult(res);

        return res
    }

    const footerSchema = createWPFooterSchema({
        url: baseUrl,
        copyright: data.footer?.copyright,
        linksSocial: data.footer?.linksSocial,
        subscribeUrl: `${baseUrl}api/subscribeUser`,
        links: data.footer.links,
    });

    return (
        <>
            <footer className={s.footer}>
                <div className={s.logo}>
                    <Logo />
                </div>
                <div className={s.centered}>
                    <div>
                        <p>
                            {data.footer.description}
                        </p>
                    </div>
                    <div className={s.newsletter}>
                        <div className={s.newsletterText}>
                            <p>NEWSLETTER</p>
                            <p>
                                {data.footer.newsletterText}
                            </p>
                        </div>

                        <form onSubmit={subscribeUser}>
                            <input type="email" placeholder="Your email" required onChange={(e) => setEmail(e.target.value)} value={email} />
                            <button type="submit">JOIN</button>
                        </form>
                        <div className={s.answer}>{result && result.status == 200 ? <p>{"Thank you for subscribing"}</p> : result && result.status == 400 ? <p>{"You're already subscribed"}</p> : undefined}</div>
                    </div>
                </div>
                <div className={s.lastColumn}>
                    <div className={s.menus}>
                        <nav className={s.social}>
                            <ul>
                                {data.footer.linksSocial.map((link, index) => (
                                    <li key={`link-social-${index}`}>
                                        <Link href={link.url} target={link.newWindow ? '_blank' : '_self'}>
                                            {link.title}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                        <nav className={s.social}>
                            <ul>
                                {data.footer.links.map((link, index) => (
                                    <li key={`link-politics-${index}`}>
                                        <Link href={link.url} target={link.newWindow ? '_blank' : '_self'}>
                                            {link.title}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </div>
                    <div className={s.copyright}>
                        <p>
                            {data.footer.copyright}
                            <br />
                            Code by <a href="https://www.ama.work" target="_blank" rel="noopener noreferrer">AMA</a>
                        </p>
                    </div>
                </div>

                {/* Mobile */}
                <div className={s.centeredMobile}>
                    <div>
                        <p>
                            {data.footer.description}
                        </p>
                    </div>
                </div>
                <div className={s.lastColumnMobile}>
                    <div className={s.menus}>
                        <nav className={s.social}>
                            <ul>
                                {data.footer.linksSocial.map((link, index) => (
                                    <li key={`link-social-${index}`}>
                                        <Link href={link.url} target={link.newWindow ? '_blank' : '_self'}>
                                            {link.title}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                        <nav className={s.social}>
                            <ul>
                                {data.footer.links.map((link, index) => (
                                    <li key={`link-politics-${index}`}>
                                        <Link href={link.url} target={link.newWindow ? '_blank' : '_self'}>
                                            {link.title}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </div>
                    <div className={s.newsletter}>
                        <div className={s.newsletterText}>
                            <p>NEWSLETTER</p>
                            <p>
                                {data.footer.newsletterText}
                            </p>
                        </div>

                        <form onSubmit={subscribeUser}>
                            <input type="email" placeholder="Your email" required onChange={(e) => setEmail(e.target.value)} value={email} />
                            <button>JOIN</button>
                        </form>
                        <div className={s.answer}>{result && result.status == 200 ? <p>{"Thank you for subscribing"}</p> : result && result.status == 400 ? <p>{"You're already subscribed"}</p> : undefined}</div>
                    </div>
                    <div className={s.copyright}>
                        <p>
                            {data.footer.copyright}
                            <br />
                            Code by <a href="https://www.ama.work" target="_blank" rel="noopener noreferrer">AMA</a>
                        </p>
                    </div>
                </div>
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(footerSchema) }}
                />
            </footer>
        </>
    )
}
